<template>
  <div class="container-fluid">
    <vehicle-form
      :loading="loading"
      :vehicleData="vehicle"
      :formErrors="formErrors"
      :showCustomer="true"
      :showMecanic="true"
      @vehicleSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultVehicle from "../defaultVehicle";
import VehicleForm from "../partials/VehicleForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    VehicleForm,
  },

  mixins: [alertLeave],

  data() {
    const vehicle = cloneDeep(defaultVehicle);
    return {
      vehicle: vehicle,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(vehicle) {
      this.loading = true;

      const vehicleData = cloneDeep(vehicle);
      delete vehicleData.id;

      try {
        await this.$store.dispatch("vehicles/add", vehicleData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("VEHICLES.VEHICLE_ADDED"),
        });
        const vehicle = this.$store.getters["vehicles/vehicle"];
        this.$emit("onViewVehicle", vehicle, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
